<template lang="pug">
main.soldPage
  .soldPage-titleBg
  h2.soldPage-title Agency <br>Sold Listings
  Slider(
    v-for='(listing, i) in soldListings',
    :key='listing.id',
    :index='i + 3',
    :listing='listing',
    sold,
    :reverse='i % 2'
  )
  Contact
</template>

<script>
  export default {
    data() {
      return {
        soldListings: null,
      };
    },
    components: {
      Slider: () => import('@/components/Slider.vue'),
      Contact: () => import('@/components/Contact.vue'),
    },
    async mounted() {
      this.soldListings = await this.$store.dispatch('getSoldListings');
      this.$store.commit('pageLoaded');
    },
  };
</script>

<style lang="scss">
  .soldPage-titleBg {
    grid-row: 2;
    grid-column: left-side / right-side;
    background-color: #1F1E1E;
  }
  .soldPage-title {
    grid-column: left-cont / right-cont;
    grid-row: 2;
    font-size: 64px;
    line-height: 77px;
    padding-top: 40px;
    padding-bottom: 0px;
    color: white;
    z-index: 1;
    @include middle {
      font-size: 52px;
      line-height: 62px;
    }
    @include phone {
      font-size: 36px;
      line-height: 43px;
      padding-top: 20px;
      padding-bottom: 0px;
    }
  }
</style>
